import { useEffect, useState } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore.js';
import { ConfirmProvider } from '@/components/ui/index.js';
import { Layout } from '@/components/Layout.js';
import { LoginPage } from '@/pages/LoginPage.js';
import { DashboardPage } from '@/pages/DashboardPage.js';
import { RoadmapPage } from '@/pages/RoadmapPage.js';
import { UsersPage } from '@/pages/UsersPage.js';
import { UserDetailPage } from '@/pages/UserDetailPage.js';
import { CodesPage } from '@/pages/CodesPage.js';
import { XianyuOpenPage } from '@/pages/XianyuOpenPage.js';
import { OrdersPage } from '@/pages/OrdersPage.js';
import { ReleasesPage } from '@/pages/ReleasesPage.js';
import { AuditLogsPage } from '@/pages/AuditLogsPage.js';
import { FeedbackPage } from '@/pages/FeedbackPage.js';
import { VisitorsPage } from '@/pages/VisitorsPage.js';
import { VisitorDetailPage } from '@/pages/VisitorDetailPage.js';
import { PricingPage } from '@/pages/PricingPage.js';
import { DevicesPage } from '@/pages/DevicesPage.js';
import { PromotionCodesPage } from '@/pages/PromotionCodesPage.js';
import { SettingsPage } from '@/pages/SettingsPage.js';

function RequireAuth({ children }: { children: React.ReactNode }): JSX.Element {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

export function App(): JSX.Element {
  const hydrate = useAuthStore((s) => s.hydrate);
  const status = useAuthStore((s) => s.status);
  const [bootDone, setBootDone] = useState(false);

  useEffect(() => {
    void hydrate().then(() => setBootDone(true));
  }, [hydrate]);

  if (!bootDone) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        加载中…
      </div>
    );
  }

  return (
    <BrowserRouter>
      <ConfirmProvider>
      <Routes>
        <Route
          path="/login"
          element={
            status === 'authenticated' ? <Navigate to="/dashboard" replace /> : <LoginPage />
          }
        />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path="/codes" element={<CodesPage />} />
          <Route path="/xianyu" element={<XianyuOpenPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/releases" element={<ReleasesPage />} />
          <Route path="/audit_logs" element={<AuditLogsPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/visitors" element={<VisitorsPage />} />
          <Route path="/visitors/:id" element={<VisitorDetailPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/promotion_codes" element={<PromotionCodesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      </ConfirmProvider>
    </BrowserRouter>
  );
}
